import type { ComponentChildren } from 'preact';
import { useHashLocation } from 'wouter-preact/use-hash-location';

interface Props {
  show?: boolean;
  link: string;
  isActive?: boolean;
  onClick: () => void;
  id: string;
  children?: ComponentChildren;
  title: string;
}

export const PerksNavMobileLink = ({
  show = true,
  link,
  isActive,
  onClick,
  id,
  children,
  title,
}: Props) => {
  if (!show) return null;
  const [, setLocation] = useHashLocation();

  const handleClick = (e: Event) => {
    e?.preventDefault();
    setLocation(link);
    requestAnimationFrame(() => window.scrollTo(0, 0));
    onClick();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };

  return (
    <div
      id={id}
      className={`mobile-nav-link ${isActive ? 'active' : ''}`}
      role="link"
      tabIndex={0}
      aria-label={title}
      aria-current={isActive ? 'page' : undefined}
      onTouchEnd={handleClick}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {children}
      <span class="mobile-nav-link-title">{title}</span>
    </div>
  );
};
